import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductSupplement } from '@next/core-lib/cart';
import { AbstractDialog, AbstractDialogData, AbstractDialogResultData, DIALOG_RETURN_TYPES, AgrDialogModule } from '@next/core-lib/dialog';
import { LocaleService } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { ProductSupplementComponent } from 'src/app/product/components/product-supplement/product-supplement.component';
import { LineItem } from 'src/app/product/models/product.models';

import * as ProductActions from 'src/app/product/store/actions';

import { SiloProductItem } from '../../models/silo-product-list.models';

interface SiloProductSupplementsWizardComponentData extends AbstractDialogData {
  siloId: number;
  siloProduct: SiloProductItem;
}

@Component({
  templateUrl: './silo-product-supplements-wizard.component.html',
  imports: [AgrDialogModule, ProductSupplementComponent],
})
export class SiloProductSupplementsWizardComponent extends AbstractDialog<SiloProductSupplementsWizardComponentData> implements OnInit {
  public siloId: number;
  public siloProduct: SiloProductItem;
  public lineItem: LineItem;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SiloProductSupplementsWizardComponentData,
    protected readonly mdDialogRef: MatDialogRef<SiloProductSupplementsWizardComponent, AbstractDialogResultData<SiloProductSupplementsWizardComponentData>>,
    private readonly localeService: LocaleService,
    private readonly store: Store,
  ) {
    super();
    this.siloProduct = this.data.siloProduct;
    this.siloId = this.data.siloId;

    this.lineItem = {
      id: this.siloProduct.id,
      title: this.siloProduct.title,
      quantity: this.siloProduct.quantity,
      orderUnit: this.siloProduct.orderingInformation.orderUnit,
      productSupplements: this.siloProduct.supplements,
    };
  }

  ngOnInit(): void {
    this.data.title = this.localeService.translate('cart.cart-column-productSupplements');
    this.data.confirmButtonText = this.localeService.translate('cart.cart-remarks-dialog.confirm');
    this.data.confirmButton = true;
  }

  cancel(): void {
    this.mdDialogRef.close({ status: DIALOG_RETURN_TYPES.cancel });
  }

  handleProductSupplementsChange(newProductSupplements: ProductSupplement[]): void {
    this.siloProduct = {
      ...this.siloProduct,
      supplements: newProductSupplements,
    };

    this.lineItem = {
      id: this.siloProduct.id,
      title: this.siloProduct.title,
      quantity: this.siloProduct.quantity,
      orderUnit: this.siloProduct.orderingInformation.orderUnit,
      productSupplements: this.siloProduct.supplements,
    };

    this.store.dispatch(
      ProductActions.setSelectedProductSiloLine({
        selectedProductSiloLine: this.siloProduct,
      }),
    );
  }

  updateSupplement(): void {
    this.lineItem = {
      id: this.siloProduct.id,
      title: this.siloProduct.title,
      quantity: this.siloProduct.quantity,
      orderUnit: this.siloProduct.orderingInformation.orderUnit,
      productSupplements: this.siloProduct.supplements,
    };

    this.store.dispatch(
      ProductActions.setSilosProductSupplement({ siloId: this.siloId, skuId: this.siloProduct.id, supplements: this.siloProduct.supplements }),
    );
    this.confirm();
  }
}
